import { ReactNode } from 'react';

interface AppBarProps {
  children: ReactNode;
}

export default function AppBar({ children }: AppBarProps): JSX.Element {
  return (
    <>
      <div className="app-bar">{children}</div>
      <style jsx>{`
        .app-bar {
          width: 100%;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          background-color: #fff;
          position: sticky;
          top: 0;
          left: 0;
          right: 0;
          z-index: 101;
        }
      `}</style>
    </>
  );
}
